import { useSessionTimeout } from 'src/hooks/use-session-timeout';
import SessionTimeoutDialog from './session-timeout-dialog';

export default function SessionTimeoutProvider() {
  const {
    showWarning,
    countdown,
    extendSession,
    logoutNow,
  } = useSessionTimeout();

  return (
    <SessionTimeoutDialog
      open={showWarning}
      countdown={countdown}
      onExtendSession={extendSession}
      onLogoutNow={logoutNow}
    />
  );
}